import { useId } from 'react'
import { hoyLocal, useAyuda } from './ContextoDeAyuda'
import { recorridoEnCurso, tipDelDia } from './seleccionDeTips'
import './tips.css'

/**
 * RF-1705 · Un consejo del día arriba del tablero. Rota por fecha local, solo enseña lo que el rol puede hacer, y
 * «Cerrar por hoy» lo quita hasta mañana. No sale con «Mostrar TIPs» apagado ni mientras corre el recorrido, para
 * no mover el tablero que el recorrido está señalando.
 */
export function TipDelDia() {
  const ayuda = useAyuda()
  const idTitulo = useId()

  const tip = ayuda.mostrarTips && !ayuda.tipDelDiaCerradoHoy && !recorridoEnCurso(ayuda) ? tipDelDia(hoyLocal(), ayuda.rol) : null
  if (!tip) return null

  return (
    <aside className="tip-del-dia" aria-labelledby={idTitulo}>
      <p className="tip-texto">
        <strong id={idTitulo}>TIP del día:</strong> {tip.texto}
      </p>
      <button type="button" className="enlace tip-cerrar" onClick={ayuda.cerrarTipDelDia}>Cerrar por hoy</button>
    </aside>
  )
}
